import React from "react";
import { withTranslation } from "react-i18next";
import { FlexRow, ButtonData } from "./TabsView.styled";

const Tabs = (props) => {
  const { t, activeTab, toggleTab, data } = props;

  return (
    <FlexRow>
      {data.isClient && (
        <div>
          <ButtonData
            marginRight="10px"
            color={activeTab === "client" ? "#008395" : "#cccccc"}
            onClick={() => toggleTab("client")}
          >
            {t("CLIENT_INFORMATION")}
          </ButtonData>
        </div>
      )}
      {data.isCentre && (
        <div>
          <ButtonData
            marginRight="10px"
            color={activeTab === "center" ? "#008395" : "#cccccc"}
            onClick={() => toggleTab("center")}
          >
            {t("CENTER_INFORMATION")}
          </ButtonData>
        </div>
      )}
      {data.isHaulier && (
        <div>
          <ButtonData
            marginRight="10px"
            color={activeTab === "haulier" ? "#008395" : "#cccccc"}
            onClick={() => toggleTab("haulier")}
          >
            {t("HAULIER_INFORMATION")}
          </ButtonData>
        </div>
      )}
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
